<template>

    <!-- ######################################################### -->
    <!-- --------------------  Results --------------------------- -->
    <!-- ######################################################### -->

    <div class="mainDivMulti" v-if="showServerUploadedfiles">

        <div style="align-items: left; align-content: left; display: block;">

            <div class="childDivToBoxDivBotMargin">
                <div style="align-items: left; align-content: left;">

                    <div style="display: flex; align-items: left; align-content: left;">

                        <span v-if="errorFoundInFileUpload" class="fontForMainFileUploadFeedbackError"
                            style="text-align: left; align-items: left;" aria-live="polite">An error occurred with the upload:
                            <ul class="fontForMainFileUploadFeedbackText" style="margin-bottom: 0px; padding-bottom: 0px;">
                                <li>
                                    <span class="material-icons editIconSlotSmall" data-tooltip="tooltip"
                                        style="color: #009900;" title="Successfully Uploaded File" aria-live="polite">
                                        check
                                    </span>
                                    <span> - Indicates uploaded</span>
                                </li>
                                <li>
                                    <span class="material-icons editIconSlotSmall" data-tooltip="tooltip"
                                        style="color: #800000;" title="File was not uploaded" aria-label="Files was not uploaded">
                                        close
                                    </span>
                                    <span> - Indicates not uploaded</span>
                                </li>
                            </ul>
                        </span>

                        <span v-else class="fontForMainFileUploadFeedback">Successful Upload:</span>
                    </div>

                </div>
            </div>

            <div class="fileBox">
                <!-- <span>{{ item.name }}</span> -->
                <table style="padding: 5px;">
                    <tr v-for="(item, index) in serverResultsFileObjList" :key="index">
                        <td class="tdAll">{{ item.fileName }}</td>
                        <td class="tdSize">
                            <span v-if="item.uploaded" class="material-icons editIconSlotSmall" data-tooltip="tooltip"
                                style="color: #009900;" title="Successfully Uploaded File" aria-label="Successfully uploaded file" aria-live="polite">
                                check
                            </span>
                            <span v-else class="material-icons editIconSlotSmall" data-tooltip="tooltip"
                                style="color: #800000;" title="File was not uploaded" aria-label="File was not uploaded" aria-live="polite">
                                close
                            </span>
                        </td>
                    </tr>
                </table>
            </div>

            <div v-if="errorFoundInFileUpload" style="text-align: left; align-items: left;">
                <div class="fontForMainFileUploadFeedbackError" style="margin-right: 10px;">Error Text:</div>
                <div style="display: block;">
                    <ul>
                        <li>
                            {{ fileUploadErrorMessage }}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="childDivToBoxDiv">
                <button @click="handleCloseServerFiles" @keydown.enter="handleCloseServerFiles" class="buttonStyleCancel" type="submit" aria-label="Close this modal window">
                    Close
                </button>
            </div>

        </div>
    </div>

    <!-- ######################################################### -->
    <!-- -------------------- Selection -------------------------- -->
    <!-- ######################################################### -->


    <!-- --------------------------------------------------------- -->
    <!-- ----------------  Upload Button ------------------------- -->
    <!-- --------------------------------------------------------- -->

    <div class="mainDivNofiles" 
         v-if="!showMultiFileSelection && !showServerUploadedfiles"
         style="padding: 0px; margin: 0px;">

        <form @submit.prevent="onSubmit" 
              id="formIDyyy" 
              style="padding: 0px; margin: 0px;"
              enctype="multipart/form-data">

            <div class="itemCenterCenter" style="text-align: left; padding: 0px; margin: 0px;">
                <label class="material-icons forIconNewRecord text-success" 
                       for="fileIDzzz"
                       style=" padding: 0px; margin: 0px;">
                    add_card 
                    <input id="fileIDzzz" 
                        style="display: none" 
                        @change="handleFileSelection" 
                        type="file" 
                        :multiple="enableMultiFileSelection" />
                </label>
            </div>

        </form>
    </div>

    <!-- --------------------------------------------------------- -->
    <!-- ----------------  Selected Files ------------------------ -->
    <!-- --------------------------------------------------------- -->

    <div class="mainDivMulti" v-if="showMultiFileSelection">
        <form @submit.prevent="onSubmit" id="formID2" enctype="multipart/form-data">

            <div v-if="enableMultiFileSelection" style="text-align: left">
                <label class="buttonStyle" for="fileIDxxx">
                    Add Additional Files
                    <input id="fileIDxxx" style="display: none" @change="handleAddAdditionalFiles" type="file" multiple />
                </label>
            </div>

            <div class="fileBox">
                <!-- <span>{{ item.name }}</span> -->
                <table style="padding: 5px;">
                    <tr v-for="(item, index) in fileDisplayArray"  :key="index">
                        <td class="tdAll">{{ item.name }}</td>
                        <td class="tdSize">{{ formatBytes(item.size) }}</td>
                        <td class="tdSize">
                            <span @click="handleRemoveFileFromUploadList(item.name)"
                                class="material-icons editIconSlotSmall" data-tooltip="tooltip" style="color: #800000;"
                                title="Remove File from Upload">
                                delete
                            </span>
                        </td>
                    </tr>
                </table>
            </div>

            <div style="align-items: left; display: flex; margin-top: 10px">
                <button @click="handleCancel" class="btn-danger" type="submit">
                    Cancel
                </button>
                <button @click="handleUploadFiles" class="btn-primary" type="submit">
                    Accept
                </button>
            </div>

        </form>
    </div>
</template>
  
<script>

export default {
    data() {
        return {

            enableFunctionTracing: true,
            enableDataLogging: false,

            //This is the list of file objects uploaded using the multi-part upload
            //control. At each step in processing, this list will always contain all
            //files currently selected for uploading. This is file form data.
            uploadFileList: null,

            //This is an array of json objects which each have two properties. Those
            //properties are file name and file size. This is the array which is displayed
            //in the HTML to show the user the file names and file sizes.
            //This data is displayed for selected files which are intended to be uploaded.
            //This is not the data displayed for file returned by the server.
            fileDisplayArray: null,

            //This is simply a copy of the component property ServerUploadFiles. The copy
            //is done since Properties are read only. I generally make a copy like this
            //even if I have no plans to modify the data. For this component, the 
            //raw property could have been used instead.
            serverUploadFiles: null,

            //This list is used to display file names and whether or not the file was uploaded.
            //The display of this data is done only in the results controls. So it is an array of
            //json objects where each object has a file name and boolean indicated the status of
            //the file upload as provided by the server.
            serverResultsFileObjList: null,

            errorFoundInFileUpload: false,
            fileUploadErrorMessage: null,

            showMultiFileSelection: false,
            showServerUploadedfiles: false,

            //Controls whether or not multi-file selection is enabled.
            enableMultiFileSelection: false,

        };
    },
    created() {
        if (this.$data.enableFunctionTracing) {
            console.log("**** created ****");
        }
        this.serverUploadFilesFnc();
        this.enableMultiFileSelectionFnc();
    },

    emits: ['proccessFiles'],

    props: {
        ServerUploadFiles: { type: Object, require: true }, //This is the raw data and is never modified.
        EnableMultiFileSelection: { type: Boolean, require: false}
    },
    watch: {
        ServerUploadFiles: {
            handler: function () {
                if (this.$data.enableFunctionTracing) {
                    console.log("**** watch ServerUploadFiles ****");
                }
                this.serverUploadFilesFnc();
            },
            flush: "post",
        },

        EnableMultiFileSelection: {
            handler: function () {
                if (this.$data.enableFunctionTracing) {
                    console.log("**** watch EnableMultiFileSelection ****");
                }
                this.enableMultiFileSelectionFnc();
            },
            flush: "post",
        },

    },
    methods: {

        // ------------------------------------------------------
        // ---------------- watch handlers ----------------------
        // ------------------------------------------------------

        enableMultiFileSelectionFnc() {
            if (this.$data.enableFunctionTracing) {
                console.log("**** serverUploadFilesFnc ****");
            }

            console.log('---> this.EnableMultiFileSelection = ', this.EnableMultiFileSelection);

            if (this.EnableMultiFileSelection != null) {
                this.$data.enableMultiFileSelection = this.EnableMultiFileSelection;
                console.log('this.$data.enableMultiFileSelection = ', this.$data.enableMultiFileSelection);
            }

        },

        serverUploadFilesFnc() {
            if (this.$data.enableFunctionTracing) {
                console.log("**** serverUploadFilesFnc ****");
            }

            if (this.ServerUploadFiles != null) {

                //Copy the property into a class attribute. 
                this.$data.serverUploadFiles = {
                    ErrorFound: this.ServerUploadFiles.ErrorFound,
                    UploadResults: this.ServerUploadFiles.UploadResults,
                    FileList: new Array
                };

                for (let i = 0; i < this.ServerUploadFiles.FileList.length; i++) {
                    this.$data.serverUploadFiles.FileList[i] = this.ServerUploadFiles.FileList[i];
                }

                if (this.$data.enableDataLogging) {
                    console.log('-------- serverUploadFilesFnc() ----------');
                    this.log_serverUploadFiles();
                }

                this.$data.serverResultsFileObjList = new Array;

                //This is true if any of the uploads failed, otherwise it is false.
                this.$data.errorFoundInFileUpload = this.$data.serverUploadFiles.ErrorFound;

                //If the upload succeeded for all files, the message returned states that fact.
                //If an error did occur, the following will capture that message.
                this.$data.fileUploadErrorMessage = this.$data.serverUploadFiles.UploadResults;

                //For each of the original files sent to the server, add the file
                //to this.$data.serverResultsFileObjList and mark as not uploaded.
                this.$data.uploadFileList.forEach((element) => {
                    if (this.$data.enableDataLogging) {
                        console.log('element.name = ', element.name);
                    }
                    this.$data.serverResultsFileObjList.push(
                        { fileName: element.name, uploaded: false }
                    );
                });

                if (this.$data.enableDataLogging) {
                    console.log('-------- serverUploadFilesFnc() ----------');
                    this.log_serverResultsFileObjList();
                }

                //For each of the file names sent back from the server, mark the file as uploaded. Since
                //all files were marked as not uploaded above, the effect is that only the files actually
                //uploaded will have an uploaded status as true, the others will have an uploaded status of false.
                this.$data.serverUploadFiles.FileList.forEach((element) => {
                    this.$data.serverResultsFileObjList.forEach((item) => {
                        if (item.fileName == element) {
                            item.uploaded = true;
                        }
                    });
                });

                if (this.$data.enableDataLogging) {
                    console.log('-------- serverUploadFilesFnc() ----------');
                    console.log('##### final serverResultsFileObjList #####');
                    this.log_serverResultsFileObjList();
                }
                this.$data.showServerUploadedfiles = true;
            }

        },

        // ------------------------------------------------------
        // ---------------- Emit Events -------------------------
        // ------------------------------------------------------

        emitFiles() {
            if (this.$data.enableFunctionTracing) {
                console.log("**** emitFiles ****");
            }
            if (this.$data.enableDataLogging) {
                this.log_uploadFileList();
            }

            this.$emit('proccessFiles', this.$data.uploadFileList);
        },

        //-------------------------------------------------------------------
        //------------- Utility Functions -----------------------------------
        //-------------------------------------------------------------------

        removeFileFrom_fileDisplayArray(fileNameToRemove) {
            if (this.$data.enableFunctionTracing) {
                console.log("**** removeFileFrom_fileDisplayArray ****");
            }
            if (this.$data.enableDataLogging) {
                console.log('fileNameToRemove = ', fileNameToRemove);
            }

            let saveFilenameList = new Array();
            this.$data.fileDisplayArray.forEach((element) => {
                saveFilenameList.push(element);
            });

            let fileCount = 0;
            this.$data.fileDisplayArray = new Array();
            saveFilenameList.forEach((element) => {
                if (element.name.trim() != fileNameToRemove.trim()) {
                    this.$data.fileDisplayArray.push(element);
                    fileCount++;
                }
            });
            return fileCount;
        },

        removeFileFrom_uploadFileList(fileNameToRemove) {
            if (this.$data.enableFunctionTracing) {
                console.log("**** removeFileFrom_uploadFileList ****");
            }
            if (this.$data.enableDataLogging) {
                console.log('fileNameToRemove = ', fileNameToRemove);
            }

            let saveFileList = new FormData();
            this.$data.uploadFileList.forEach((element) => {
                saveFileList.append("files", element);
            });

            this.$data.uploadFileList = new FormData();
            saveFileList.forEach((element) => {
                if (element.name.trim() != fileNameToRemove.trim()) {
                    this.$data.uploadFileList.append("files", element);
                }
            });

            return;
        },

        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'

            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

            const i = Math.floor(Math.log(bytes) / Math.log(k))

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        },

        //-------------------------------------------------------------------
        //------------- Event Handlers --------------------------------------
        //-------------------------------------------------------------------

        handleCloseServerFiles() {
            if (this.$data.enableFunctionTracing) {
                console.log("handleCloseServerFiles()");
            }
            this.$data.showServerUploadedfiles = false;
        },

        handleFileSelection() {
            if (this.$data.enableFunctionTracing) {
                console.log("**** handleFileSelection ****");
            }

            this.$data.showMultiFileSelection = true;

            let fileUploadCtrl = document.getElementById("fileIDzzz");

            if (this.$data.enableDataLogging) {
                console.log("-----> #aaaaaaa <-------");
                this.log_fileUploadCtrl(fileUploadCtrl);
            }

            this.$data.uploadFileList = new FormData();

            for (let fileItem of fileUploadCtrl.files) {
                this.$data.uploadFileList.append("files", fileItem);
            }

            this.$data.fileDisplayArray = new Array();

            if (this.$data.enableDataLogging) {
                console.log("-----> #bbbbbbb <--------");
                this.log_uploadFileList();
            }

            this.$data.uploadFileList.forEach((element) => {
                let displayItem = {
                    name: element.name,
                    size: element.size
                };
                this.$data.fileDisplayArray.push(displayItem);
            });
        },

        handleUploadFiles() {
            if (this.$data.enableFunctionTracing) {
                console.log("**** handleUploadFiles ****");
            }
            this.$data.showMultiFileSelection = false;
            this.emitFiles();
        },

        handleRemoveFileFromUploadList(fileToRemoveName) {
            if (this.$data.enableFunctionTracing) {
                console.log("**** handleRemoveFileFromUploadList ****");
            }

            let remainingFiles = this.removeFileFrom_fileDisplayArray(fileToRemoveName);
            this.removeFileFrom_uploadFileList(fileToRemoveName);

            if (this.$data.enableDataLogging) {
                console.log('fileToRemoveName = ', fileToRemoveName);
                console.log('fileDisplayArray: remainingFiles : ', remainingFiles);
                this.log_fileDisplayArray();
                this.log_uploadFileList();
            }

            if (remainingFiles == 0) {
                this.$data.showMultiFileSelection = false;
            }
        },

        //This method captures the selected files for upload
        //and adds them to the existing list this.$data.uploadFileList.
        handleAddAdditionalFiles() {
            if (this.$data.enableFunctionTracing) {
                console.log("**** handleAddAdditionalFiles ****");
            }

            let fileUploadCtrl = document.getElementById("fileIDxxx");

            //Only add a file if it isn't already in this.$data.uploadFileList.
            let newFile = true;
            for (let fileItem of fileUploadCtrl.files) {

                //Check to see if the proposed new file is already in the
                //file list. If it is, it does not get added again, otherwise
                //it is added to the file list.
                this.$data.uploadFileList.forEach((element) => {
                    if (element.name.trim() == fileItem.name.trim()) {
                        newFile = false;
                    }
                });

                if (newFile) {
                    this.$data.uploadFileList.append("files", fileItem);
                }
                newFile = true;
            }

            this.$data.fileDisplayArray = new Array();
            this.$data.uploadFileList.forEach((element) => {

                let displayItem = {
                    name: element.name,
                    size: element.size
                };
                this.$data.fileDisplayArray.push(displayItem);
            });

            //------- logging -------
            if (this.$data.enableDataLogging) {
                console.log("-----> #ddddddd <-------");
                this.log_fileUploadCtrl(fileUploadCtrl);

                console.log("-----> #eeeee <--------");
                this.log_uploadFileList();

                console.log("-----> #ffffff <--------");
                this.log_fileDisplayArray();
            }
        },

        handleCancel() {
            if (this.$data.enableFunctionTracing) {
                console.log("**** handleCancel ****");
            }

            this.$data.showMultiFileSelection = false;
            this.$data.uploadFileList = new FormData();
            this.$data.fileDisplayArray = new Array();
        },

        //-------------------------------------------------------------------
        //------------- Logging Functions -----------------------------------
        //-------------------------------------------------------------------

        log_uploadFileList() {
            if (this.$data.enableDataLogging) {
                console.log('-------- log_uploadFileList() START --------------');
                console.log('sssssssssssssssssssssssssssssssssssssssssssssssssssss');

                this.$data.uploadFileList.forEach((element) => {
                    console.log('-------- log_uploadFileList ----------');
                    console.log("uploadFileList: element = ", element);
                    console.log("uploadFileList: element.name = ", element.name);
                    console.log("uploadFileList: element.size = ", element.size);
                    console.log("uploadFileList: element.type = ", element.type);
                    console.log("uploadFileList: element.lastModifiedDate = ", element.lastModifiedDate);
                });
                console.log('-------- log_uploadFileList() END --------------');
                console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');
            }
        },

        log_fileUploadCtrl(ctrl) {
            if (this.$data.enableDataLogging) {
                console.log('-------- log_fileUploadCtrl() START --------------');
                console.log('sssssssssssssssssssssssssssssssssssssssssssssssssssss');
                console.log('ctrl = ', ctrl);
                for (let fileItem of ctrl.files) {
                    console.log("------ log_fileUploadCtrl ---------");
                    console.log("fileUploadCtrl: fileItem = ", fileItem);
                    console.log("fileUploadCtrl: fileItem.name = ", fileItem.name);
                }
                console.log('-------- log_fileUploadCtrl() END --------------');
                console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');
            }
        },

        log_fileDisplayArray() {
            if (this.$data.enableDataLogging) {
                console.log('-------- log_fileDisplayArray() START --------------');
                console.log('sssssssssssssssssssssssssssssssssssssssssssssssssssss');
                for (let fileItem of this.$data.fileDisplayArray) {
                    console.log("----- log_fileDisplayArray ----------");
                    console.log("fileUploadCtrl: fileItem.name = ", fileItem.name);
                    console.log("fileUploadCtrl: fileItem.size = ", fileItem.size);
                }
                console.log('-------- log_fileDisplayArray() END --------------');
                console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');
            }
        },

        log_serverUploadFiles() {
            console.log('-------- log_serverUploadFiles() START --------------');
            console.log('sssssssssssssssssssssssssssssssssssssssssssssssssssss');
            console.log('this.$data.serverUploadFiles.ErrorFound = ', this.$data.serverUploadFiles.ErrorFound);
            console.log('this.$data.serverUploadFiles.UploadResults = ', this.$data.serverUploadFiles.UploadResults);
            console.log('this.$data.serverUploadFiles.FileList:');
            for (let i = 0; i < this.$data.serverUploadFiles.FileList.length; i++) {
                console.log('fileName = ', this.$data.serverUploadFiles.FileList[i]);
            }
            console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');
            console.log('-------- log_serverUploadFiles() END --------------');
        },

        log_serverResultsFileObjList() {
            console.log('-------- log_serverResultsFileObjList() START --------------');
            console.log('sssssssssssssssssssssssssssssssssssssssssssssssssssss');
            for (let i = 0; i < this.$data.serverResultsFileObjList.length; i++) {
                console.log('fileName = ', this.$data.serverResultsFileObjList[i].fileName, ', uploaded = ',
                    this.$data.serverResultsFileObjList[i].uploaded);
            }
            console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');
            console.log('-------- log_serverResultsFileObjList() END --------------');
        },
    },
};
</script>
  

<style scoped>
/* ---------- containers -------------------- */

.itemCenterCenter {
  display: flex;
  align-items: center;
  justify-content: start;
}

.mainDivMulti {
    align-items: left;
    display: flex;
    border: 2px black solid;
    background-color: #d9d9d9;
    padding: 10px;
}

.fontForMainFileUploadFeedback {
    font-size: 18px;
    color: #000099;
    font-weight: bold;
}

.fontForMainFileUploadFeedbackError {
    font-size: 18px;
    color: #800000;
    font-weight: bold;
}

.fontForMainFileUploadFeedbackText {
    font-size: 18px;
    color: black;
    font-weight: normal;
}

.mainDivNofiles {
    align-items: left;
    display: flex;
}

.childDivToBoxDiv {
    width: 100%;
    align-items: left;
    align-content: left;
    display: flex;
}

.childDivToBoxDivBotMargin {
    width: 100%;
    align-items: left;
    align-content: left;
    display: flex;
    margin-bottom: 10px;
}

/* ---------- buttons -------------------- */

.buttonStyle {
    border: 1px solid black;
    padding: 5px;
    border-radius: 5px;
    background-color: lightblue;
    cursor: pointer;
}

.buttonStyleCancel {
    margin-left: 5px;
    border: 1px solid black;
    padding: 5px;
    border-radius: 5px;
    background-color: lightblue;
    cursor: pointer;
}

/* ---------- table -------------------- */
.editIconSlotSmall {
    margin: 0px;
    font-size: 20px;
    margin-left: 0px;
    vertical-align: middle;
    cursor: pointer;
}

.fileBox {
    align-items: left;
    display: flex;
    background-color: #f2f2f2;
    padding: 5px;
    border: 1px solid black;
    margin-bottom: 10px;
}

.tdAll {
    padding: 5px;
    text-align: left;
}

.tdSize {
    padding: 5px;
    padding-left: 10px;
    text-align: left;
}
</style>

  